import script from "./EmptyArray.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyArray.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyArray.vue?vue&type=style&index=0&id=33a874e7&scoped=true&lang=scss"

import exportComponent from "D:\\NewLODAPC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a874e7"]])

export default __exports__